import React, { useState, useCallback, useEffect } from "react";
import { connect } from "react-redux";
import * as actions from "../../../../store/actions";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { DEFAULT_PIC } from "../../../../constants/image";
import { getDashboardPath } from "../../../../constants";
import "./CompletedAppointment.css";
import AppointmentIcon from "../../../../components/uiElements/icons/profileIcons/AppointmentIcons";
import ChatAfterAppointment from "./PostAppointmentChat";
import { getUserData } from "../../../../utils/localStorage";
import { convertTimeTo12HourFormat} from "../../../../utils/parseDateTime";

const AppointmentsCompleted = ({ appointmentData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  const handleCallback = () => {
    setIsOpen(false);
    setModalShow(false);
  };

  const user_data = getUserData();

  return (
    <>
      {isOpen && (
        <ChatAfterAppointment
          isfirst={isOpen}
          appointment={appointmentData}
          parentCallback={handleCallback}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      )}
      <div
        className="col-xs-4 appointment-complt"
        style={{
          border: appointmentData?.is_visit_now
            ? "1px solid var(--icon-color)"
            : "1px solid #f2f2f2",
        }}
      >
        <div className="mb-4">
          <img
            src={appointmentData?.patient_detail?.image || DEFAULT_PIC}
            className="profile-image-secondary"
            alt={appointmentData?.id}
          />
          <span className="patient-name">
            {appointmentData?.patientName}{" "}
            {user_data?.chat_notify?.is_chat_listen &&
              appointmentData?.id ==
                parseInt(user_data?.chat_notify?.appointmentID) && (
                <span
                  className="is-dot-icon mb-0"
                  style={{ marginTop: "17px" }}
                />
              )}
          </span>
          <span className="float-right">
            <AppointmentIcon
              type="chat"
              onClick={e => {
                setIsOpen(true);
                setModalShow(true);
              }}
            />
          </span>
          {!appointmentData.is_visit_now && (
            <Link
              to={getDashboardPath(
                `/appointments/detail/${appointmentData?.id}`
              )}
              className="link"
            >
              <span className="float-right">
                <AppointmentIcon type="viewProfile" />
              </span>
            </Link>
          )}
        </div>

        <div className="mb-2">
          <AppointmentIcon type="clock" />
          <span>
            {convertTimeTo12HourFormat(appointmentData.startTime)}
          </span>
        </div>
        <div className="row">
          <span className="col-md-1">
            <AppointmentIcon type="bars" />
          </span>
          <span className={classnames("col-md-10 pl-2 ")}>
            {appointmentData.topic}
          </span>
        </div>
      </div>
    </>
  );
};

const mapStoreToProps = ({ dashboard }) => ({
  chat_details: dashboard.ongoingAppointment,
});

const mapDispatchToProps = dispatch => ({
  setOngoingAppointmentData: updatedData =>
    dispatch(actions.setOngoingAppointmentData(updatedData)),
});

export default connect(
  mapStoreToProps,
  mapDispatchToProps
)(AppointmentsCompleted);
